import { Link, useNavigate } from "react-router";
import { useUrlQuery, useWithUrlQuery } from "./UrlUtils";
import { useT } from "./Lang";

export type Paging = {
  page: number;
  pageSize: number;
  totalCount: number;
};

export function PagerDB(props: { paging: Paging; tab?: string }) {
  const navigate = useNavigate();
  const urlQuery = useUrlQuery();
  const withUrlQuery = useWithUrlQuery();
  const t = useT();
  const from = (props.paging.page - 1) * props.paging.pageSize + 1;
  const to = Math.min(
    props.paging.page * props.paging.pageSize,
    props.paging.totalCount
  );
  const lastPage = Math.ceil(props.paging.totalCount / props.paging.pageSize);
  const path = (page: number) =>
    props.tab ? `${props.tab}?p=${page}` : `?p=${page}`;

  return (
    <div className="pager">
      {props.paging.page > 1 && (
        <div
          onClick={() => navigate(path(props.paging.page - 1))}
          className="link"
        >
          {t({ en: "Prev", ru: "Предыдущая" })}
        </div>
      )}
      {from} - {to} of {props.paging.totalCount}
      {props.paging.page < lastPage && (
        <div
          onClick={() => navigate(path(props.paging.page + 1))}
          className="link"
        >
          {t({ en: "Next", ru: "Следующая" })}
        </div>
      )}
    </div>
  );
}

export function Pager(props: { paging: Paging }) {
  const urlQuery = useUrlQuery();
  const t = useT();
  const withUrlQuery = useWithUrlQuery();

  const mkUrl = (page: number) =>
    withUrlQuery({ ...urlQuery, p: page === 1 ? undefined : page.toString() });
  const from = (props.paging.page - 1) * props.paging.pageSize + 1;
  const to = Math.min(
    props.paging.page * props.paging.pageSize,
    props.paging.totalCount
  );
  const lastPage = Math.ceil(props.paging.totalCount / props.paging.pageSize);

  return (
    <div className="pager">
      {props.paging.page > 1 && (
        <Link to={mkUrl(props.paging.page - 1)} preventScrollReset rel="prev">
          {t({ en: "Prev", ru: "Предыдущая" })}
        </Link>
      )}
      {from} - {to} of {props.paging.totalCount}
      {props.paging.page < lastPage && (
        <Link to={mkUrl(props.paging.page + 1)} preventScrollReset rel="next">
          {t({ en: "Next", ru: "Следующая" })}
        </Link>
      )}
    </div>
  );
}

export function applyPaging<T>(all: T[], search: { p?: string }) {
  const paging: Paging = {
    page: parseInt(search.p ?? "1") || 1,
    pageSize: 50,
    totalCount: all.length,
  };
  const from = (paging.page - 1) * paging.pageSize;
  return [all.slice(from, from + paging.pageSize), paging] as const;
}
